import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Title = styled(Typography.Title)`
  text-align: center;
  text-transform: uppercase;
  color: ${({ theme }) => theme.palette.secondary.labels};
  padding: 10px 0;
`;

export const Subtitle = styled.div`
  padding: 15px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.secondary.labels};
  border-top: 1px solid ${({ theme }) => theme.palette.primary.border};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.border};
  margin-bottom: 15px;
  display: grid;
  gap: 10px;
`;

export const SubtitleText = styled(Typography.Body).attrs(() => ({
  $variant: '1',
}))`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const SubtitleBonus = styled.div`
  background-color: ${({ theme }) => theme.palette.secondary.background};
  padding: 10px;
  border-radius: 7px;
  position: relative;
`;

export const SubtitleBonusRow = styled.div`
  display: grid;
  grid-template-columns: 60px 1fr;
  align-items: center;

  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
`;

export const SubtitleBonusText = styled(Typography.Body).attrs(() => ({
  $variant: '3',
}))`
  color: ${({ theme }) => theme.palette.secondary.labels};
`;

export const SubtitleBonusMessageOld = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  color: ${({ theme }) => theme.palette.primary.labels};
  text-decoration: line-through;
  display: flex;
  align-items: center;
  gap: 1px;
  text-transform: uppercase;
  padding-left: 5px;
  font-size: 12px;
  font-weight: 500;
`;

export const SubtitleBonusMessage = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))`
  padding: 5px 7px;
  background-color: ${({ theme }) => theme.palette.primary.background};
  color: ${({ theme }) => theme.palette.primary.labels};
  border-radius: 30px;
  max-width: fit-content;
  display: flex;
  align-items: center;
  gap: 1px;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
`;

export const SubtitleBonusLabel = styled(Typography.Caption).attrs(() => ({
  $variant: '2',
}))<{ $bgColor: string }>`
  text-transform: uppercase;
  position: absolute;
  top: 0;
  right: 0;
  color: ${({ theme }) => theme.palette.primary.background};
  padding: 5px 7px;
  border-radius: 0 7px;
  font-size: 12px;
  font-weight: 500;

  background-color: ${({ $bgColor }) => $bgColor};
`;

export const NoveltyLabel = styled(Typography.Caption).attrs(() => ({
  $variant: '1',
}))`
  text-transform: lowercase;
  padding: 5px 10px;
  border-radius: 25px;
  background-color: ${({ theme }) => theme.palette.tertiary.background};
  color: ${({ theme }) => theme.palette.brand.main};
`;

export const ServiceLabelText = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const NewPrice = styled(Typography.Header).attrs(() => ({
  $variant: '4',
  as: 'span',
}))<{ $isWhite?: boolean }>`
  color: ${({ theme, $isWhite }) =>
    $isWhite ? theme.palette.primary.background : theme.palette.brand.main};
`;
